import {use} from 'react';

import {isNil} from 'ramda';

import {ChartCardContext} from '../contexts/ChartCardContext';

/**
 * Props for the expandable `Card` of a chart. In a chart grid, the grid item keeps the expanded
 * state, because a collapsed card must not fill the height of its row. Outside a chart grid, the
 * card keeps its own state.
 */
export function useChartCardExpansion() {
  const card = use(ChartCardContext);

  return isNil(card) ? {} : {isExpanded: card.isExpanded, onExpandButtonClick: card.toggleExpanded};
}
